import React from 'react'
import styles from './TimelineItem1.module.css'

const TimelineItem1=({data})=>(
    <div className={styles.timeline_item}>
        <div className={styles.timeline_item_content}>
            <span className={styles.tag} style={{background:data.category.color}}>
                {data.category.tag}
            </span>
            <time>{data.year}</time>
            <p className={styles.pr}>{data.text}</p>
            <span className={styles.circle}></span>
        </div>

    </div>
);

export default TimelineItem1